import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
// Zet de paginataal direct bij het laden op Nederlands, nog voordat de
// SEO-component (Helmet) dat per pagina doet.
document.documentElement.lang = 'nl';
render(<AppRouter data-id="element-987" data-mp="21ck7lyttmoon" />, document.getElementById('root'));